
import { CoreLogService } from "../log.service";
import { Subject } from "rxjs";
import { Coordinates } from "./comEnvironmentGeolocationCoordinates";

/** Geolokalisierung */

export interface Geolocation {
  /** Gibt die aktuelle Position zurück
  * @param highAccuracy Erzwingt die Verwendung des GPS-Moduls (falls vorhanden)
  * @param timeout Maximale Zeit in Millisekunden die das Ermitteln der Koordinaten in anspruch nehmen darf (Standard: Unendlich)
  * @param maximumAge Wenn gesetzt wird nach Möglichkeit ein gecachter Wert herausgeben welcher in der angegebnen Zeit in Millisekunden ausgelesen wurde anstatt die Position erneut zu ermitteln
  */
  currentPosition(highAccuracy: boolean, timeout: number, maximumAge: number): Promise<Coordinates>;

  /** Überwacht die aktuelle Position
   * @param highAccuracy Erzwingt die Verwendung des GPS-Moduls (falls vorhanden)
   * @param timeout Maximale Zeit in Millisekunden die das Ermitteln der Koordinaten in anspruch nehmen darf (Standard: Unendlich)
   * @param maximumAge Wenn gesetzt wird nach Möglichkeit ein gecachter Wert herausgeben welcher in der angegebnen Zeit in Millisekunden ausgelesen wurde anstatt die Position erneut zu ermitteln
   */
  watchPosition(highAccuracy: boolean, timeout: number, maximumAge: number): Subject<Coordinates>;
}

export class GeolocationDefault implements Geolocation {

  constructor(private _coreLogService: CoreLogService) {
  }

  /** Gibt die aktuelle Position zurück
   * @param highAccuracy Erzwingt die Verwendung des GPS-Moduls (falls vorhanden)
   * @param timeout Maximale Zeit in Millisekunden die das Ermitteln der Koordinaten in anspruch nehmen darf (Standard: Unendlich)
   * @param maximumAge Wenn gesetzt wird nach Möglichkeit ein gecachter Wert herausgeben welcher in der angegebnen Zeit in Millisekunden ausgelesen wurde anstatt die Position erneut zu ermitteln
   */
  public async currentPosition(highAccuracy: boolean = false, timeout: number = Infinity, maximumAge: number = 0): Promise<Coordinates> {
    return new Promise<Coordinates>((resolve, reject) => {
      try {
        const positionOptions = <PositionOptions>{
          enableHighAccuracy: highAccuracy,
          timeout: timeout,
          maximumAge: maximumAge
        };

        navigator.geolocation.getCurrentPosition((browserCoordinates) => {
          const coordinates = new Coordinates(true, browserCoordinates.coords.longitude, browserCoordinates.coords.latitude, browserCoordinates.coords.accuracy);
          resolve(coordinates);
        }, reject, positionOptions);
      } catch (ex) {
        this._coreLogService.error("Geolocation.currentPosition: Koordinaten konnten nicht ermittelt werden", ex);
        reject(ex);
      }
    });
  }

  /** Überwacht die aktuelle Position
   * @param highAccuracy Erzwingt die Verwendung des GPS-Moduls (falls vorhanden)
   * @param timeout Maximale Zeit in Millisekunden die das Ermitteln der Koordinaten in anspruch nehmen darf (Standard: Unendlich)
   * @param maximumAge Wenn gesetzt wird nach Möglichkeit ein gecachter Wert herausgeben welcher in der angegebnen Zeit in Millisekunden ausgelesen wurde anstatt die Position erneut zu ermitteln
   */
  public watchPosition(highAccuracy: boolean = false, timeout: number = Infinity, maximumAge: number = 0): Subject<Coordinates> {
    try {
      const positionSubject = new Subject<Coordinates>();
      const positionOptions = <PositionOptions>{
        enableHighAccuracy: highAccuracy,
        timeout: timeout,
        maximumAge: maximumAge
      };

      navigator.geolocation.watchPosition((browserCoordinates) => {
        const coordinates = new Coordinates(true, browserCoordinates.coords.longitude, browserCoordinates.coords.latitude, browserCoordinates.coords.accuracy);
        positionSubject.next(coordinates);
      }, (error) => {
        this._coreLogService.error("Geolocation.watchPosition", "Fehler beim Überwachen der Position", error);
        positionSubject.error(error);
      }, positionOptions);

      return positionSubject;
    } catch (ex) {
      this._coreLogService.error("Geolocation.watchPosition", "Koordinaten konnten nicht überwacht werden", ex);
      return null;
    }
  }
}
